var mr = Object.defineProperty;
var pr = (e, r, t) => r in e ? mr(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var P = (e, r, t) => pr(e, typeof r != "symbol" ? r + "" : r, t);
import { jsxs as k, jsx as a, Fragment as _ } from "react/jsx-runtime";
import { instrumentService as fr, createSpanName as nt, SpanComponent as ot, debug as te, ImprHeaders as he, Logger as ct, normalizeAxiosError as gr, useAutoFocus as lt, updateUrl as Er, addSpanEvent as X, error as Pt, isApiErrorLike as St, stringifyLoggable as Ct, useUnMounted as vr, TERMINATE_REASON_CODE as Re, comparePropsEqual as br, COMMON_MODULE_BUILD_VERSION as wr, COMMON_MODULE_APP_VERSION as Ar, instrument as yr } from "@imprivata-cloud/common";
import * as K from "react";
import { useState as F, useId as Ue, useEffect as S, useCallback as v, Component as Ir, Children as Tr, isValidElement as Nt, useRef as w, createContext as Mt, useMemo as De, useContext as Sr, forwardRef as Cr, createElement as Lt, memo as Nr, createRef as Lr } from "react";
import { l as Rr, s as Ce, o as Oe, p as Dr, h as kr, Q as st, g as L, q as Rt, U as at, m as Ye, e as Ke, F as Ut, n as xr, A as Ne, d as Ge, S as Fr, r as Or, t as Pr, u as He, v as be, a as Mr, N as Ur, R as Br, w as _r, L as Vr, j as Wr } from "./index-B_Mi3W2t.js";
import { InputBox as Le, Button as Q } from "@imprivata-cloud/components";
import { Form as Bt, Tooltip as jr, Flex as Me, Menu as Dt, Space as _t, Dropdown as zr, Row as kt, Col as qe } from "antd";
import { useTranslation as V } from "react-i18next";
import { f as Hr, s as qr, a as Yr, c as Kr, u as ie, i as se, F as Qr, b as Vt, E as ut, d as ae, p as we, g as Gr, e as Xr, h as Jr, I as Zr, j as $r, k as en, O as tn, l as rn, m as nn, A as on } from "./face-Dml70xnv.js";
import { PlusSquareOutlined as sn, RetweetOutlined as an } from "@ant-design/icons";
import { A as R, b as cn, C as xt, P as Fe } from "./api-DwyZ-w1t.js";
import { jsonToBase64 as Wt } from "@imprivata-cloud/dataprivacy";
import { B as ln, C as un } from "./ConsentSteps-Boru81Lg.js";
const dn = (e) => fr(nt(ot.SERVICE, "push"), {
  fetchPushStatus: async () => Rr().then((r) => (te("[FactorSvc] fetched push status"), r))
}), hn = ({ traceContext: e }) => {
  const r = Object.freeze({ traceContext: e }), t = Object.assign(
    {},
    { uid: Date.now() },
    structuredClone(r)
  );
  return te("[Authn::store] creatingStore", { uid: t.uid }), {
    get(n) {
      return t[n];
    },
    set(n) {
      if (!n) {
        console.debug("[Authn::store] cannot set state, no key provided");
        return;
      }
      switch (te(`[Authn::store] Setting state for key=${n.key}: `, {
        uid: t.uid,
        data: n.data
      }), n.key) {
        case "traceContext":
          t.traceContext = n.data;
          break;
      }
    },
    remove(n) {
      if (n in t && t[n]) {
        te(`[Authn::store] removing key ${n}`, { uid: t.uid });
        const s = t[n];
        return t[n] = void 0, s;
      }
      console.debug(`[Authn::store] key ${n} not found or already empty`);
    }
  };
};
function mn(e) {
  const {
    requestConfig: r,
    tracing: { workflowId: t },
    tenantId: n
  } = e;
  r != null && r.clientName && Ce(he.ImprClientName, Wt({ name: r.clientName })), Ce(he.ImprTenantId, n), t && Ce(he.ImprWorkflowId, t), console.debug("[App] default headers set");
}
const pn = (e) => {
  const { store: r, requestConfig: t } = e, { inAppSessionHeader: n } = t || {}, s = Object.freeze(r || hn({})), o = {
    ...n && { [he.ImprInAppSession]: n } || {}
  };
  mn(e);
  const i = { commonHeaders: o, store: s }, h = Hr({ ...e, ...i }), c = qr({ ...e, ...i, factorService: h }), u = Yr({ ...e, ...i, sessionService: c }), f = dn({ ...e }), p = Kr({ ...e });
  return console.debug("[Authn::services] Services created"), {
    store: s,
    fetchFactors: h.fetchFactors,
    startSession: c.startSession,
    terminateSession: c.terminateSession,
    authenticateFactor: u.authenticate,
    enroll: u.enroll,
    fetchPushStatus: f.fetchPushStatus,
    authenticateByEnrollmentSession: u.authenticateByEnrollmentSession,
    submitConsent: p.submitConsent
  };
}, fn = (e) => {
  if (e.data === void 0 || e.data === null)
    throw new Error("Generic error to stop the flow.");
  return e.data;
}, gn = (e) => {
  console.debug("onErrorInterceptor", e), Dr(he.ImprSessionId);
  const { status: r, responseData: t } = gr(e), n = kr(r, t == null ? void 0 : t.error);
  return console.error(
    `Returning interceptor error (type=${typeof n}): `,
    n,
    t
  ), Promise.reject(n || t);
}, En = (e) => (ct.request(e), e), vn = (e) => (ct.response(e), e), bn = async (e) => (ct.error(e), Promise.reject(e));
let Qe = [], Pe = [];
const wn = () => {
  (Qe.length || Pe.length) && jt(), Qe.push(Oe.interceptors.request.use(En)), Pe.push(
    Oe.interceptors.response.use(
      vn,
      bn
    )
  ), Pe.push(
    Oe.interceptors.response.use(fn, gn)
  );
}, jt = () => {
  for (const e of Qe)
    Oe.interceptors.request.eject(e);
  for (const e of Pe)
    Oe.interceptors.response.eject(e);
  Qe = [], Pe = [];
}, zt = ({
  initValue: e = "",
  disabled: r = !1,
  onSubmit: t,
  usernameLabel: n = "",
  loading: s = !1
}) => {
  const [o, i] = F(e), { t: h } = V(), c = lt(), u = Ue(), f = (l) => {
    i(l.target.value.trim());
  }, p = (l) => {
    l.preventDefault(), t(o);
  }, g = n ? h("login.username.custom-label", {
    username: n,
    // Prevent HTML Entities from being screened twice - by i18n function and then by react
    interpolation: { escapeValue: !1 }
  }) : h("login.username.label");
  return S(() => {
    const l = () => {
      var E;
      (E = c == null ? void 0 : c.current) == null || E.focus();
    };
    return document.body.addEventListener("click", l), () => {
      document.body.removeEventListener("click", l);
    };
  }, [c]), /* @__PURE__ */ k("form", { onSubmit: p, "data-testid": "username-form", className: "flex flex-column", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-column", style: { gap: "1rem" }, children: [
      /* @__PURE__ */ a("h2", { "data-testid": "username-input-label", className: "face-subtitle", children: g }),
      /* @__PURE__ */ a(
        Bt.Item,
        {
          label: h("login.username.username"),
          colon: !1,
          style: { marginBottom: "0" },
          layout: "vertical",
          children: /* @__PURE__ */ a(
            Le,
            {
              ref: c,
              type: "text",
              placeholder: "",
              value: o,
              "data-testid": "username-input",
              onChange: f,
              autoFocus: !r,
              width: "100%",
              size: "middle",
              className: "primary-body",
              containerClassName: "m-b-1",
              id: `usernameInput-${u}`,
              maxLength: 255,
              role: "textbox"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ a(
      Q,
      {
        type: "primary",
        size: "middle",
        label: h("actions.continue") || void 0,
        disabled: !o.length || r,
        "data-testid": "submit-button",
        block: !0,
        htmlType: "submit",
        loading: s
      }
    )
  ] });
}, An = (e, r) => {
  if (e.length <= r)
    return e;
  const t = r / 2 - 3;
  return `${e.slice(0, t)}...${e.slice(-1 * t)}`;
};
function yn({
  title: e,
  dataTestId: r,
  className: t = "",
  maxLength: n = 30,
  ...s
}) {
  const o = e.length > n;
  return /* @__PURE__ */ a(jr, { ...s, title: o ? e : "", children: /* @__PURE__ */ a("span", { title: e, "data-testid": r, className: t, children: An(e, n) }) });
}
const Ht = ({
  initValue: e = "",
  disabled: r = !1,
  onSubmit: t,
  username: n,
  allowChangeUsername: s,
  onChangeUsername: o,
  submitLabel: i
}) => {
  const { t: h } = V(), c = lt(), [u, f] = F(e), [p, g] = F(!!e), l = Ue(), E = (y) => {
    f(y.target.value);
  }, d = v(
    (y) => {
      y.preventDefault(), g(!0);
      try {
        t(u), y.currentTarget.elements.namedItem(
          "passwordInput"
        ).focus();
      } catch (A) {
        console.error("Error:", A);
      } finally {
        g(!1);
      }
    },
    [t, u]
  );
  return S(() => {
    const y = () => {
      var A;
      (A = c == null ? void 0 : c.current) == null || A.focus();
    };
    return r || y(), document.body.addEventListener("click", y), () => {
      document.body.removeEventListener("click", y);
    };
  }, [c, r]), /* @__PURE__ */ k(Me, { className: "w-100", gap: "middle", vertical: !0, justify: "center", children: [
    /* @__PURE__ */ a("h2", { children: h("password.title") }),
    /* @__PURE__ */ k("form", { className: "password-form w-100", onSubmit: d, children: [
      s && /* @__PURE__ */ k("div", { className: "password-form-username", children: [
        /* @__PURE__ */ a(
          yn,
          {
            dataTestId: "entered-username",
            className: "entered-username",
            title: n || ""
          }
        ),
        /* @__PURE__ */ a(
          Q,
          {
            tabIndex: 0,
            className: "change-username-button",
            "data-testid": "change-username-button",
            onClick: o,
            onKeyUp: (y) => {
              y.key === "Enter" && o && typeof o == "function" && o();
            },
            children: h("login.password.change-username-button", { defaultValue: "Change" })
          }
        )
      ] }),
      /* @__PURE__ */ a(
        Bt.Item,
        {
          label: h("login.password.password"),
          colon: !1,
          style: { marginBottom: "0" },
          layout: "vertical",
          children: /* @__PURE__ */ a(
            Le,
            {
              ref: c,
              type: "password",
              name: "passwordInput",
              placeholder: "",
              value: u,
              "data-testid": "password-input",
              onChange: E,
              disabled: r,
              width: "100%",
              id: `passwordInput-${l}`,
              capsLockTooltip: { label: h("password.caps-lock-tooltip") },
              containerClassName: "m-b-1",
              autoFocus: !0
            }
          )
        }
      ),
      /* @__PURE__ */ a(
        Q,
        {
          type: "primary",
          label: i || h("actions.continue") || void 0,
          disabled: !u.length || r || p,
          "data-testid": "submit-button",
          block: !0,
          htmlType: "submit"
        }
      )
    ] })
  ] });
};
class In extends Ir {
  constructor(r) {
    super(r), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0, didCatch: !0 };
  }
  componentDidCatch(r, t) {
    var n, s;
    console.error("ErrorBoundary caught an error: ", r, t), (s = (n = this.props).onError) == null || s.call(n, r, t);
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
const dt = () => {
  const { t: e } = V(), r = new URLSearchParams(window.location.search).get(
    st.SHOW_ADD_METHOD
  ), t = new URLSearchParams(window.location.search).get(st.TENANT_ID);
  if (!r)
    return null;
  const { ussLink: n } = Er(
    window.location.host,
    { ussLink: { sub: "access.app", path: `/self-service?tenantId=${t}` } },
    "https://"
  ), s = () => window.open(n, "_blank", "noopener,noreferrer"), o = /* @__PURE__ */ a(Dt, { children: /* @__PURE__ */ a(Dt.Item, { style: { padding: "1rem", fontSize: "1rem" }, onClick: s, children: /* @__PURE__ */ k(_t, { align: "center", style: { columnGap: 12 }, children: [
    /* @__PURE__ */ a(sn, {}),
    /* @__PURE__ */ a("span", { children: e("factor-switch.add-method-btn") })
  ] }) }, "add-method") });
  return /* @__PURE__ */ a(_, { children: /* @__PURE__ */ a(
    zr,
    {
      trigger: ["click"],
      dropdownRender: () => o,
      placement: "top",
      overlayStyle: { width: "max-content", minWidth: "238px" },
      children: /* @__PURE__ */ a(Q, { type: "link", label: e("factor-switch.primary-btn"), icon: /* @__PURE__ */ a(an, {}) })
    }
  ) });
}, Tn = ({ username: e, title: r, body: t, continueFn: n }) => {
  const { t: s } = V(), { emitEvent: o } = ie();
  return S(() => (o({ event: L.START_ENROLLING, data: !0 }), () => o({ event: L.START_ENROLLING, data: !1 })), [o]), /* @__PURE__ */ k(kt, { gutter: [0, 24], justify: "center", children: [
    /* @__PURE__ */ a(qe, { children: /* @__PURE__ */ a("h2", { className: "getting-started-title", "data-testid": "getting-started-title", children: r }) }),
    /* @__PURE__ */ a(qe, { className: "getting-started-body", children: /* @__PURE__ */ k("p", { children: [
      e,
      ", ",
      t
    ] }) }),
    /* @__PURE__ */ a(kt, { gutter: [10, 0], justify: "center", align: "middle", children: /* @__PURE__ */ a(qe, { children: /* @__PURE__ */ a("span", { className: "getting-started-username", children: e }) }) }),
    /* @__PURE__ */ a(qe, { span: 24, children: /* @__PURE__ */ a(
      Q,
      {
        type: "primary",
        htmlType: "submit",
        label: s("actions.continue"),
        onClick: n,
        block: !0
      }
    ) })
  ] });
};
function ht({
  factor: e,
  Component: r,
  ...t
}) {
  return /* @__PURE__ */ a(r, { ...t });
}
ht.whyDidYouRender = !0;
const mt = ({
  current: e,
  fallback: r,
  children: t
}) => {
  const n = Tr.toArray(t);
  return /* @__PURE__ */ k(_, { children: [
    n.find((s) => Nt(s) && e ? s.props.factor === e : !1) || r,
    n.filter((s) => Nt(s) ? !(s != null && s.props && "factor" in s.props) || !s.props.factor : !1)
  ] });
};
mt.whyDidYouRender = !0;
const Sn = (e) => !!("data" in e && e.data || e.target && "form" in e.target && e.target.form || e.target && "value" in e.target && e.target.value), Cn = 3e4, qt = ({ username: e, container: r, onIdle: t, current: n }) => {
  const s = w(), [o, i] = F(!1), [h, c] = F(0), [u] = F(n);
  S(() => {
    const p = (l) => {
      if (Sn(l)) {
        if (l.globalTimerIgnore)
          return;
        i((E) => E || !0);
      }
    }, g = r.current;
    for (const l of Rt)
      g == null || g.addEventListener(l, p);
    return () => {
      for (const l of Rt)
        g == null || g.removeEventListener(l, p);
    };
  }, [r]);
  const f = () => {
    s.current && (clearTimeout(s.current), s.current = void 0), c(Date.now());
  };
  return S(() => {
    const p = n !== u || o || !!e;
    if (!s.current && p) {
      const g = setTimeout(() => {
        (!n || ![R.IMPR_ID, R.IID_DISABLED].includes(n)) && (console.log("[Authn::TIMER] (global) idle event, setTimeout"), t());
      }, Cn);
      s.current = g;
      for (const l of at)
        window.addEventListener(l, f);
      return () => {
        s.current = void 0, clearTimeout(g);
        for (const l of at)
          window.removeEventListener(l, f);
      };
    }
  }, [o, n, u, t, e, h]), null;
}, Nn = ({ username: e }) => {
  const { emitEvent: r } = ie(), { enroll: t, authenticateByEnrollSession: n, retry: s } = Dn(), o = async (c) => {
    te("FaceEnroll enrolling before");
    try {
      const u = await t(c);
      if (console.debug("FaceEnroll enrolling response: ", u), se(u))
        return X("enroll-failed", { error: `${u}`, msg: "Enroll failed" }), u;
      X("enroll-success");
    } catch (u) {
      return X("error", { error: Vt(u), is_in_catch: !0 }), se(u) ? u : Ke({ error: u });
    }
  }, i = v(async () => {
    try {
      const c = await n();
      if (se(c)) {
        const u = Ye(c, R.FACE_ID);
        return r({ event: L.ERROR, data: u }), u;
      }
    } catch (c) {
      console.error("Error in FaceEnroll: ", c), r({
        event: L.ERROR,
        data: Ye(c, R.FACE_ID)
      });
    }
  }, [n, r]), h = v((c) => {
    console.error("[FaceLiveness]: ", c);
  }, []);
  return /* @__PURE__ */ a(
    Qr,
    {
      username: e,
      reset: s,
      enroll: o,
      onSuccessfulEnrollment: i,
      onError: h
    }
  );
}, Ln = ht, Rn = ({ factor: e, isTimerDisabled: r, ...t }) => {
  const n = w(null), { loading: s, error: o } = ie(), { t: i } = V(), h = /* @__PURE__ */ a(_, { children: s ? /* @__PURE__ */ a("div", { children: i("login.loading") }) : /* @__PURE__ */ a("h4", { children: i("errors.unknown-auth-method", { method: e || "unknown" }) }) }), c = v(() => {
  }, [r]);
  return o && o instanceof Ut ? /* @__PURE__ */ a(ut, { error: o }) : /* @__PURE__ */ a(_, { children: /* @__PURE__ */ a(
    "div",
    {
      ref: n,
      className: [
        "flex",
        "flex-column",
        "flex-grow-1",
        "flex-align-center",
        "flex-justify-space-between",
        "h-100",
        "w-100"
      ].join(" "),
      children: /* @__PURE__ */ k(mt, { current: e, fallback: h, children: [
        /* @__PURE__ */ a(Ln, { factor: R.FACE_ID, Component: Nn, ...t }),
        /* @__PURE__ */ a(qt, { container: n, onIdle: c, current: e })
      ] })
    }
  ) });
}, Yt = Mt(null), Dn = () => {
  const e = Sr(Yt);
  if (!e)
    throw new Error("useEnroll must be used within an EnrollProvider");
  return e;
}, kn = ({
  factor: e,
  username: r,
  enrollStatus: t,
  // TODO: Currently this is here to enforce a session has been created.
  // This may need to change or move.
  enrollSession: n,
  apiService: s
}) => {
  const { emitEvent: o, setLoading: i, error: h } = ie(), { t: c } = V(), u = v(
    async (l, E) => {
      var d;
      te("[EnrollCtx::authenticateByEnrollSession]"), i(!0);
      try {
        const { session: y, response: A } = await s.authenticateByEnrollmentSession(l, E), { nextFactors: U, oidcAuthorizationCode: I } = A;
        return o({
          event: L.SUCCESS,
          data: { factorType: e, nextFactor: (d = U == null ? void 0 : U[0]) == null ? void 0 : d.factorType, enrolling: !0 }
        }), o({
          event: L.AUTHENTICATED,
          data: {
            oidcAuthorizationCode: I,
            codingContext: y.encode,
            enrolling: !0,
            username: r
          }
        }), { session: y, response: A };
      } catch (y) {
        return console.error("[EnrollCtx::Error] Error authenticating (post face enroll)", { error: y }), o(xr(y)), y instanceof Ne ? y : Ke();
      } finally {
        i(!1);
      }
    },
    [s, r, e, i, o]
  ), f = v(
    async (l, E) => {
      if (!E && !n) {
        X("enroll-session-check-failed", { msg: "No auth session" });
        const d = new Ne({ message: "No session", code: Ge.SESSION_EXPIRED });
        return o({ event: L.ERROR, data: d }), d;
      }
      return s.enroll(l, E || n).then(() => {
        X("enroll-success"), X("enroll-success", { factorType: l.factorType }), o({ event: L.ENROLLED });
      }).catch((d) => (X("enroll-failed", { error: d }), d instanceof Fr ? o({ event: L.NO_SESSION, data: d }) : l.factorType !== R.FACE_ID && o({ event: L.ERROR, data: d }), d instanceof Ne ? d : Ke()));
    },
    [s, o, n]
  ), p = v(() => {
    o({ event: L.RESTART_STATE }), o({ event: L.INTERNAL_RESTART });
  }, [o]), g = De(
    () => ({ authenticateByEnrollSession: u, enroll: f, retry: p }),
    [u, f, p]
  );
  return t === "UNKNOWN" ? h ? /* @__PURE__ */ a("div", { className: "w-100 flex flex-column", children: /* @__PURE__ */ a(
    Q,
    {
      label: c("actions.again"),
      type: "primary",
      block: !0,
      disabled: !0,
      onClick: () => o({ event: L.INTERNAL_RESTART })
    }
  ) }) : /* @__PURE__ */ a(_, {}) : /* @__PURE__ */ a(Yt.Provider, { value: g, children: /* @__PURE__ */ a(Rn, { factor: e, username: r }) });
}, xn = [R.FACE_ID], Fn = ({
  apiService: e,
  modalRoot: r,
  children: t,
  applicationId: n
}) => {
  const {
    state: { nextFactors: s, username: o, session: i, enrollSession: h },
    updateAuthState: c,
    authenticate: u
  } = ae(), { emitEvent: f, setLoading: p, error: g } = ie(), { t: l } = V(), E = s.length > 0 ? s[0] : void 0, d = E && xn.includes(E.factorType), [y, A] = F(!0), [U, I] = F(), [O, re] = F(), [H, N] = F({
    consented: "UNKNOWN",
    enrolled: "UNKNOWN"
  }), { consented: ne, enrolled: W } = H, B = w(!1), q = () => {
    f({ event: L.CANCEL });
  }, oe = (T) => {
    const C = se(T) ? T : Ke();
    f({ event: L.ERROR, data: C });
  }, me = v(
    (T) => {
      c({ username: T }), f({ event: L.RESTART_STATE });
    },
    [c, f]
  ), G = v(
    async (T) => {
      re(!0), I(T);
      try {
        const C = ne === "NEEDED", D = await u(
          we(R.PASSWORD, { version: "1.0", username: o, password: T }),
          !C,
          // enrolling?
          !0
          // Transient
        );
        if (se(D)) {
          te("Consent authenticate Failed: ", { response: D });
          return;
        }
        f({ event: L.RESTART_STATE });
      } catch (C) {
        console.debug("Consent submit error: ", C);
      } finally {
        re(!1);
      }
    },
    [o, f, u, ne]
  ), j = v(
    async (T, C) => {
      var D;
      if (!o) {
        Pt("Username is required to consent", { username: o, factorState: H, stateOfResidence: C });
        return;
      }
      p(!0);
      try {
        if (te(`SubmitConsent: grantType: ${T}`), await Or({
          consent: {
            consentType: cn.BIOMETRICS,
            userId: "",
            documentName: ((D = H.consent) == null ? void 0 : D.documentName) || ln,
            grantType: T,
            residenceState: C
          },
          username: o
        }), W === "NOT_ENROLLED" && T !== xt.DECLINED) {
          const x = await u(
            we(R.PASSWORD, { version: "1.0", username: o, password: U }),
            !0,
            !0
          );
          if (se(x)) {
            console.debug("FaceEnroll authenticate Failed: ", x), f({ event: L.SESSION_FAILED, data: x });
            return;
          }
        }
        if (N((x) => ({ ...x, consented: "CONSENTED" })), W === "ENROLLED" && c({ session: void 0 }), T === xt.DECLINED) {
          A(!0), f({ event: L.INTERNAL_RESTART }), f({ event: L.CANCEL });
          return;
        }
      } catch (x) {
        if (te("Consent submit failed:", { error: x }), St(x)) {
          const ce = Ye(
            "error" in x ? x.error : x,
            R.FACE_ID
          );
          f({ event: L.ERROR, data: ce });
        }
      } finally {
        p(!1);
      }
    },
    [f, H, o, p, W, u, U, c]
  );
  return S(() => {
    if (!d || B.current)
      return;
    const T = W === "UNKNOWN";
    B.current = !!(o && T), o && T && (p(!0), (async () => {
      try {
        const { enrolled: C, consentData: D } = await Pr({
          factorType: R.FACE_ID,
          username: o,
          authnContext: Xr(),
          applicationId: n || Gr()
        }), x = !!(D.actionType === "NONE" && D.residenceState);
        N((ce) => ({
          ...ce,
          consent: D,
          consented: x ? "NOT_NEEDED" : "NEEDED",
          enrolled: C ? "ENROLLED" : "NOT_ENROLLED"
        }));
      } catch (C) {
        if (console.debug("Check consent/enroll failed:", { error: C }), N((D) => ({ ...D, enrolled: "UNKNOWN" })), St(C)) {
          const D = Ye(
            "error" in C ? C.error : C,
            R.FACE_ID
          );
          D.code === Ge.USER_NOT_FOUND && c({ username: void 0 }), f({ event: L.ERROR, data: D });
        }
      }
    })());
  }, [o, f, c, p, d, W, n]), o ? E != null && E.factorType ? W === "UNKNOWN" || ne === "UNKNOWN" ? g ? /* @__PURE__ */ a("div", { className: "w-100 flex flex-column", children: /* @__PURE__ */ a(
    Q,
    {
      label: l("actions.again"),
      type: "primary",
      block: !0,
      disabled: !0,
      onClick: () => f({ event: L.INTERNAL_RESTART })
    }
  ) }) : /* @__PURE__ */ a("span", { children: "Loading..." }) : W === "NOT_ENROLLED" && y ? /* @__PURE__ */ a(
    Tn,
    {
      username: o,
      title: l("face.getting-started.title"),
      body: l("face.getting-started.body-text"),
      continueFn: () => A(!1)
    }
  ) : ne === "NEEDED" ? !i && !h ? /* @__PURE__ */ a(
    Ft,
    {
      username: o,
      loading: O,
      onSubmit: G
    }
  ) : H != null && H.consent ? /* @__PURE__ */ a(
    un,
    {
      handleSubmitConsent: j,
      modalRoot: r,
      consent: H.consent,
      onCancel: q,
      onError: oe
    }
  ) : /* @__PURE__ */ a(_, {}) : W === "NOT_ENROLLED" ? h ? h ? /* @__PURE__ */ a(
    kn,
    {
      factor: E == null ? void 0 : E.factorType,
      username: o,
      apiService: e,
      enrollStatus: W,
      enrollSession: h
    }
  ) : /* @__PURE__ */ a(_, {}) : /* @__PURE__ */ a(
    Ft,
    {
      username: o,
      loading: O,
      onSubmit: G
    }
  ) : t : /* @__PURE__ */ a(_, {}) : /* @__PURE__ */ k(
    Me,
    {
      vertical: !0,
      flex: 1,
      justify: "space-between",
      align: "center",
      className: "w-100 flex-align-self-stretch",
      children: [
        /* @__PURE__ */ a("div", { className: "username w-100 h-100", children: /* @__PURE__ */ a(zt, { initValue: o, disabled: !1, onSubmit: me }) }),
        /* @__PURE__ */ a(dt, {})
      ]
    }
  );
}, Ft = ({
  username: e,
  loading: r,
  onSubmit: t
}) => {
  const { t: n } = V();
  return /* @__PURE__ */ k(
    Me,
    {
      vertical: !0,
      flex: 1,
      justify: "space-between",
      align: "center",
      className: "w-100 flex-align-self-stretch",
      children: [
        /* @__PURE__ */ a(
          Ht,
          {
            disabled: r,
            onSubmit: t,
            allowChangeUsername: !1,
            username: e,
            submitLabel: n("actions.continue")
          }
        ),
        /* @__PURE__ */ a(dt, {})
      ]
    }
  );
}, On = ["FACE_MASK_FOUND"], Kt = (e) => {
  const {
    state: { username: r }
  } = ae(), t = new URLSearchParams(window.location.search).get(st.SHOW_VIDEO) ?? "", n = ["false", "0", "off"].includes(t.toLowerCase()), { authenticate: s } = ae(), { emitEvent: o, error: i } = ie(), { t: h } = V(), [c, u] = F();
  S(() => {
    o({ event: L.START_AUTHENTICATING, data: R.FACE_ID });
  }, [o]);
  const f = v(
    async (g) => {
      const { image: l, deviceType: E } = g ?? {};
      if (X("is-image-present", { imageWidth: l.width, imageHeight: l.height }), l)
        try {
          const d = Jr(He.Enrolling), y = Zr[He.Enrolling], A = $r[He.Enrolling], U = { type: y, quality: A }, { imageData: I } = await en(l, U, d) ?? {};
          if (!I)
            return u(be.FAILED), console.error("No image data captured"), !1;
          const O = await s({
            ...we(R.FACE_ID, { imageData: I }, { deviceType: E }),
            username: r
          });
          return O instanceof Ne ? (console.error("Authentication failed", O), u(be.FAILED), X("auth-failed", { error: Ct(O) }), o({ event: L.ERROR, data: O }), !1) : (u(be.SUCCESS), console.debug("Authentication success"), X("auth-success", { response: Ct(O) }), !0);
        } catch (d) {
          u(be.FAILED), X("error", { error: Vt(d), is_in_catch: !0 }), console.error("Error authenticating face: ", d);
        }
      return !1;
    },
    [s, o, r]
  ), p = v(
    (g) => {
      u(be.FAILED), console.error("Face ID authentication failed", g), o({ event: L.ERROR, data: g instanceof Ne ? g : void 0 });
    },
    [o]
  );
  return r ? /* @__PURE__ */ a(
    tn,
    {
      flow: He.Authenticating,
      status: c,
      loading: !1,
      username: r,
      actions: /* @__PURE__ */ a(_, { children: c === be.FAILED ? /* @__PURE__ */ a(Me, { gap: "middle", className: "w-100", vertical: !0, children: /* @__PURE__ */ a(
        Q,
        {
          label: h("actions.again"),
          type: "primary",
          disabled: se(i) && i.code === Ge.OFFLINE,
          onClick: () => o({ event: L.INTERNAL_RESTART }),
          block: !0
        }
      ) }) : /* @__PURE__ */ k(Me, { vertical: !0, flex: 1, justify: "space-between", align: "center", children: [
        /* @__PURE__ */ a("p", { className: "authenticating-message", children: `${h("face.auth.authenticating")} ${r}` }),
        /* @__PURE__ */ a(dt, {})
      ] }) }),
      children: /* @__PURE__ */ a(
        rn,
        {
          onValid: f,
          onFailure: p,
          overrideSettings: {
            minFaceQuality: 0.45,
            maxFaceMaskProbability: 1
          },
          ignoredFeedbacks: On,
          visualOptions: { hideVideo: n, disableBlur: c !== be.FAILED }
        }
      )
    }
  ) : (Pt("Face attempted without username, aborting"), /* @__PURE__ */ a(_, {}));
};
Kt.whyDidYouRender = !0;
const Pn = (e) => {
  if (e.length === 0)
    return "";
  e.sort((s, o) => new Date(s.lastUsedAt).getTime() - new Date(o.lastUsedAt).getTime());
  const t = e[e.length - 1].deviceModel;
  return Mr.t(`data.${t}`, {
    ns: "deviceModel",
    defaultValue: t
  });
}, Qt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABYCAYAAACzpXSwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATOSURBVHgB7ZvPbxtFFMffrteNt41jr4nVOpDUNaglCYojW6Q5GokraiUEUn9IGIkLAgQXRG9t/wKIuJUKGtEmCA7NESQkygmI5MpJWqdJVSdpqDdNTGzLLt7UP5Z52xp5bYcWZ5Jdp/O5JJoZ2+87897MvNEMBw0YDIWdlgfFd4Avh1TgBjkALxiAChDlQF0ElZuITF4ZbdSGqy0IDp04DmD5xufrdgYDfvD5ekCSnGAEicR9kOX7cDM2B7HZeSIEztUK0QkIHD31uUtyfPLWm28Qww+CmUilMnDh4rewvp4+d31y7Hyl3FL5JzB8+uzznv1nPng/DG53J5gNUbRBMDgAt2/HQx12nzORmPkJyzUBgVdPhl0uxxdovM1mA7NiFQQY8PfB1ExsWHK9NCXfu3FLc6Hg0VMLn336oVeSHLoP2GxW4v97oW2PADzPwU6TVwqQyyqQzW3oyuPxJeJOl9Ml0XqIx97v7z1SZzwa3uVxgEhEGGE8gr/tdts1W6rB+PQdOujk8xthnuPhWF//YV0De3sbSM69YBbQFvSGaoKBATIDcSFeVTmv58B+XWW73Xxx0GgUyCTq5zkOBru69ALEGrVmAOOwmscu7+WhRdgsDltGwGYwAUbDBBgNE2A0TIDRMAFG0/IChEaFP/8yC2bE53XXlTEXMprdGQPN0P2Cixx7WJ6qbbFYgrt/rgMNqAlYpmTQ/4XFgNE8u0F84u0hcgBG5/wom1Ng/PtJaIbmR0AFemzhu5oegfEfmusx2rAgNprdOQu9/lovmJH4QrKujOUDRsMEGA3LByqwfKBJmACjYfkAFVg+0MIwAUbT8vkAcyGjYQKMhiU0jUil/4Z8/iEUS2UoFkogCDxI0j5qe6dqqArAe56JlQyIbQIIVgvYH18eVEj52loWEnIGerpdVO/kURUgy2kQxT3aNclqI7Hnnc59IK+kYS2ZhR6SftKCWgzglhhxd9ob9rCVuBHW4c4TXYwW1ASgUe2kp9HQzUBhomjVXI0W1ARgsKJxTwJv4CpmFCA85ZEKthMs9GZvigJ4ct5TfmK7VOoB0ISaAJx90Lf/y7/xQAvdp/Ye9FagJgBvvCtk8cIeLjQYCW2NINMs1tFc0KitA+jbHo+TzPUZWF7+S5uRKkGt5AtQKD0ShQsZTaguZDhN+ryd2pqA02qO/MXYEKyCVicdcABttmUvhC6yHfueRrDttNEwAUazOwWUyzRPbrcXFLCYSqV1hRsPi2A28nn9FkWWV0BVIUoEqNH4wpKuMpWil3DQIlfzHDGRWAWOU5d4FbhfI5EZXSVuuMwkAm2pZHwVYrNzQBRc5csb1kvx+FIaH1jqPkS2Aqtrubqh2ykwDvG38SCgNgVFl78Rm1uM/H5l9NFr1qHTxyVXx9WPP3rP1M9xEUVRYOTLi0RUJowCtDRKvjd9S3ruiDQ/f2fY7+8jG7Bt2SJtGTT+wleXIbmaPB/5Y2wEy/7NA4mIHzucL3JT0zdD/X2HtRfUZgJd/OtL35HzpeRIZHLsTKW87oFiYPhkmBx9nH2l92UvPtPFl661j0V3CvT1ePwuRK5Pwx0Sp5yl/G7kt/GJ6jabvnRGIVyZP6aC6sUXr2AAZDld5FQuSqy8VhJzo9FrE+naNv8AyR20/cEM9AUAAAAASUVORK5CYII=", Mn = 15e3, Un = ({ onManualTokenEntrySelected: e, deviceModel: r }) => {
  const { t } = V(), [n, s] = F(!1);
  return S(() => {
    let o = !1;
    const i = setTimeout(() => {
      o || s(!0);
    }, Mn);
    return () => {
      o = !0, clearTimeout(i);
    };
  }, []), /* @__PURE__ */ k("form", { "data-testid": "push-info-form", children: [
    /* @__PURE__ */ a("div", { "data-testid": "push-info-label", className: "formLabel subtitle", children: n ? /* @__PURE__ */ a(_, { children: /* @__PURE__ */ k(_t, { wrap: !0, style: { width: "100%", justifyContent: "center" }, children: [
      t("login.token.label-1"),
      /* @__PURE__ */ a(
        Q,
        {
          type: "text",
          "data-testid": "manual-code-link",
          label: t("login.token.label-btn", { defaultValue: "code" }),
          block: !1,
          onClick: e,
          style: {
            display: "inline",
            fontSize: "20.25px",
            fontWeight: "600",
            lineHeight: "24px",
            padding: "0px"
          }
        }
      ),
      t("login.token.label-2"),
      " ",
      r
    ] }) }) : /* @__PURE__ */ k(_, { children: [
      t("login.push.info"),
      " ",
      r
    ] }) }),
    /* @__PURE__ */ a("img", { src: Qt, alt: "phoneImg", style: { marginBottom: "36px" } })
  ] });
}, Bn = ({
  disabled: e = !1,
  onSubmit: r,
  deviceModel: t
}) => {
  const [n, s] = F(!1), [o, i] = F(""), { t: h } = V(), c = Ue(), u = (g) => {
    i(g.target.value.trim());
  }, f = (g) => {
    const l = /^\d+$/;
    g.key === "Enter" && o.trim() !== "" ? (g.preventDefault(), r(o)) : !l.test(g.key) && g.key !== "Backspace" && g.preventDefault();
  };
  return /* @__PURE__ */ k("form", { onSubmit: (g) => {
    g.preventDefault(), s(!0), r(o);
  }, children: [
    /* @__PURE__ */ k("label", { htmlFor: "tokenInput", "data-testid": "token-input-label", className: "formLabel subtitle", children: [
      h("login.token.label"),
      " ",
      t
    ] }),
    /* @__PURE__ */ a("img", { src: Qt, alt: "phoneImg", style: { marginBottom: "36px" } }),
    /* @__PURE__ */ a(
      Le,
      {
        type: "password",
        placeholder: h("login.token.input-placeholder") || "",
        value: o,
        "data-testid": "token-input",
        onChange: u,
        onKeyDown: f,
        autoFocus: !e,
        disabled: e || n,
        width: "100%",
        size: "large",
        className: "primary-body",
        id: `tokenInput-${c}`,
        capsLockTooltip: { label: h("password.caps-lock-tooltip") },
        containerClassName: "m-b-1"
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        type: "primary",
        size: "large",
        label: h("actions.continue") || void 0,
        disabled: !o.length || e || n,
        "data-testid": "submit-button",
        block: !0,
        htmlType: "submit"
      }
    )
  ] });
}, _n = 3e4, Vn = 45e3, Wn = 500, it = (e) => {
  const r = w(), t = w(), n = w(), {
    state: { modelData: s, pushInitiated: o },
    authenticate: i,
    terminateSession: h,
    toggleFactorSwitch: c
  } = ae(), [u, f] = F(!1), [p, g] = F(o === !1), l = vr(), E = s && Pn(s), d = v(
    (I) => {
      n.current && clearInterval(n.current), n.current = void 0, t.current && clearTimeout(t.current), t.current = void 0, I && (r.current && clearTimeout(r.current), r.current = void 0);
    },
    [n, t]
  ), y = v(
    (I) => {
      d(!0), i(we(R.IMPR_ID, { version: "1.0", totp: I })).then((O) => {
        se(O) ? console.error("Error authenticating for ImprID: ", O) : f(!0);
      }).catch((O) => {
        console.error("Error authenticating for ImprID: ", O);
      });
    },
    [i, d]
  ), A = v(() => {
    g(!0), d();
  }, [d]), U = v(() => new Promise((I, O) => O(new Error("NOT IMPLEMENTED"))).then((I) => {
    if (console.debug("[ImprId::doPolling] status: ", I), se(I))
      throw console.error("Error for ImprID: ", I), I;
    switch (I) {
      case Fe.PUSH_TIMEOUT:
      case Fe.ACCEPTED:
      case Fe.REJECTED:
        console.debug("[ImprId::doPolling] status: ", I), d(!0), I === Fe.PUSH_TIMEOUT && !l.current ? (g(!0), d()) : I === Fe.ACCEPTED && (console.debug("[ImprId::doPolling] finised: "), f(!0));
        break;
    }
  }).catch((I) => {
    console.debug("[ImprId::doPolling] Catch Block", I), e.factor === R.IID_DISABLED ? (console.debug("[ImprId::doPolling] Catch Block - Push Disabled: Do not clear timers"), clearInterval(n.current)) : d(!0);
  }), [d, l, e.factor]);
  return S(() => {
    if (!r.current) {
      const I = setTimeout(() => {
        d(!0), h(Re.TIMEOUT);
      }, Vn);
      return r.current = I, () => {
        r.current = void 0, clearTimeout(I);
      };
    }
  }, [h, d]), S(() => {
    if (!n.current && !u)
      return n.current = setInterval(U, Wn), () => {
        n.current && clearInterval(n.current), n.current = void 0;
      };
  }, [u, U, c]), S(() => {
    if (!t.current && !u)
      return t.current && clearTimeout(t.current), t.current = setTimeout(() => {
        A();
      }, _n), () => {
        t.current && (clearTimeout(t.current), t.current = void 0);
      };
  }, [u, A]), u ? /* @__PURE__ */ a(_, {}) : /* @__PURE__ */ a("div", { className: ["w-100"].join(" "), children: p ? /* @__PURE__ */ a(Bn, { deviceModel: E, onSubmit: y }) : /* @__PURE__ */ a(
    Un,
    {
      deviceModel: E,
      onManualTokenEntrySelected: A
    }
  ) });
};
it.whyDidYouRender = !0;
const jn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABTCAYAAADA6WrVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARNSURBVHgB7ZrPThNRFMbPudMiy/oGdedCY99AfAAjiYEYIbGsTONCeQLgCXSDwIqaICKQAIkbV9SV7oBE1/YNLLuGljmeO50p06bM/zudae63oDPT6dfh67lz7/3NRRih2ep2qXjdnkWCcu+IOBcF83yvXmtCAsqaP7p3XlQ3ytcdXOHNKoxWwyjSUtSLzap/P4S56noFusYpEJTAR0i4ur/7eg1CKMv+hvwjE6Su+DlggNDg/RMU9B0RW3zkvuu9mYcPnl7++f3tFwRQ1v2tSphf2PxL4LQfaBLS0uFOrTHwRS+41AxxBEAV+1CrU7xz77i+1PK7yKz7i+eLW7MuAzCu6cmwgdTeXq3ZKU494dSa9qHS1FX7HfgoD/5CED1znVuXJ8MtkqmZnLKzT4ivwEd58Me5xa0zoF6JcBmNTHFYcwub//jFan+I5H0DI3zl/FJZ9OcmcbeARCWy3yx0+6XiKS6pFtkmRFaXFEhZ9J9ut0sFkndO6sXQLViJ+hq522CYXyqL/u3p6RZXgnlBgFZzECbM8EvDy2Du5UbVtdvc36mtep0/v7BR5n+lnFV/q3cwEerOEa6Kt7LPvc1ADke5z3WXZwN8lAd/Yd1IsP9lJR52ns4vfpwdNpDmxc7Vab+UEFrcHfmO6tLxx/M4/tZgqTeQwDOAgSFnA4HN0bzkm9Nj3p9xm3ITWj78/PoDBJBK//nFrRUiWh3xVmD/m7nDy/UKonHkvmncpjABqPR3B8Dd45pw3STD+Atn42D3zbng0RYBfbr101zWVl8cMgAV/gMVQNYweTWqP446V5ZvpyAqBpj2IAqaRgcaXqOxMIrrPxzAwW6tHscfIWfyCyCKchWCigCkchOCqgCkchGCygCkMh+C6gCkRoaQFRocNYCJoc1RApgo2gy9ic2MtRUwgDjX35s7yAS7PLYfprUmXDCtZdCJjxg5DExKePq5/PVLwLlDBH9LYSogxvUX5B+TZ15wM7kJRGtNQSvc9upBaHAUf5A0eGr6GAIo7vVr2gyaNlv+goFE5eagxwzMlp2y0wTKsjvy/EAO/IWkzc4JYWitsy1pree5OfAX1HtOZ8mmtb4aprWe5+bAX0ja7Bywaa2nRtFar/Pz4K9pM0wMbY7nn3vanIR/rmlzUv65pc1J+o+VNvNobxtkCSO8M7p0Mi6aPVay5Cyz4RvUvaQCiCIBWjoEKR0C6BAsjZU285j3Pe+WeFBTFUXzh17bPEZ/vbYZ9NpmvbZZr23WtHnQX9NmTZs1be77a9qsabOmzZo2a9qsafOErG0et7+WlpbWxGssj+FU0+ywSjUE1bQ5qlILQTVtjiMDUpBq2hxXqVSCatocV8qfRaqmzUlIeQiqaXMSUv9UWjVtTkDKQ1BNm5OQ8hBU0+YklEIlqKXNSUh5CKppcxJSHoJq2pyEUhksqabNcZXe3EExbY6j1FavqabNcTQWnpA1GvwfGyqpNe6VHRQAAAAASUVORK5CYII=", zn = ({
  disabled: e = !1,
  onSubmit: r,
  pinLabel: t = ""
}) => {
  const { t: n } = V(), s = Ue(), [o, i] = F(""), h = (p) => {
    i(p.target.value.trim());
  }, c = (p) => !/^[a-zA-Z0-9]*$/.test(p.key) && p.key !== "Backspace" && p.key !== "Tab" ? (p.preventDefault(), !1) : !0, u = v(
    (p) => {
      var l;
      p.preventDefault();
      const g = (l = p == null ? void 0 : p.currentTarget) == null ? void 0 : l.elements;
      r(o).then(() => {
        i(""), g && g.namedItem("pinInput").focus();
      });
    },
    [r, o]
  ), f = t ? n("login.pin.custom-label", {
    pin: t,
    // Prevent HTML Entities from being screened twice - by i18n function and then by react
    interpolation: { escapeValue: !1 }
  }) : n("login.pin.label");
  return /* @__PURE__ */ k("form", { onSubmit: u, "data-testid": "impr-pin-form", children: [
    /* @__PURE__ */ a("label", { htmlFor: `pin-${s}`, "data-testid": "pin-input-label", className: "formLabel subtitle", children: f }),
    /* @__PURE__ */ a("img", { src: jn, alt: "PIN", className: "pinImage", "data-testid": "pin-icon" }),
    /* @__PURE__ */ a(
      Le,
      {
        type: "password",
        name: "pinInput",
        placeholder: "",
        value: o,
        className: "m-b-1",
        "data-testid": "pin-input",
        onChange: h,
        autoFocus: !0,
        disabled: e,
        width: "100%",
        size: "large",
        id: `pin-${s}`,
        capsLockTooltip: { label: n("password.caps-lock-tooltip") },
        onKeyDown: c,
        onPaste: (p) => {
          p.preventDefault();
        }
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        type: "primary",
        size: "large",
        label: n("actions.continue") || void 0,
        disabled: !o.length || e,
        "data-testid": "submit-button",
        block: !0,
        htmlType: "submit"
      }
    )
  ] });
}, Gt = (e) => {
  const [r, t] = F(!1), { authenticate: n } = ae(), s = v(
    async (o) => {
      t(!0), await n(we(R.IMPR_PIN, { pin: o })).catch((i) => {
        console.error("[ImprPin] Error:", i);
      }).finally(() => {
        t(!1);
      });
    },
    [n]
  );
  return /* @__PURE__ */ a("div", { className: ["w-100"].join(" "), children: /* @__PURE__ */ a(zn, { disabled: r, onSubmit: s }) });
};
Gt.whyDidYouRender = !0;
var Hn = Object.create, Xt = Object.defineProperty, qn = Object.getOwnPropertyDescriptor, Yn = Object.getOwnPropertyNames, Kn = Object.getPrototypeOf, Qn = Object.prototype.hasOwnProperty, Gn = (e, r) => () => (r || e((r = { exports: {} }).exports, r), r.exports), Xn = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function") for (let s of Yn(r)) !Qn.call(e, s) && s !== t && Xt(e, s, { get: () => r[s], enumerable: !(n = qn(r, s)) || n.enumerable });
  return e;
}, Jn = (e, r, t) => (t = e != null ? Hn(Kn(e)) : {}, Xn(!e || !e.__esModule ? Xt(t, "default", { value: e, enumerable: !0 }) : t, e)), Zn = Gn((e, r) => {
  (function(t, n) {
    typeof e == "object" && typeof r < "u" ? n(e) : typeof define == "function" && define.amd ? define(["exports"], n) : (t = typeof globalThis < "u" ? globalThis : t || self, n(t.fastUniqueNumbers = {}));
  })(e, function(t) {
    var n = function(l) {
      return function(E) {
        var d = l(E);
        return E.add(d), d;
      };
    }, s = function(l) {
      return function(E, d) {
        return l.set(E, d), d;
      };
    }, o = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, i = 536870912, h = i * 2, c = function(l, E) {
      return function(d) {
        var y = E.get(d), A = y === void 0 ? d.size : y < h ? y + 1 : 0;
        if (!d.has(A)) return l(d, A);
        if (d.size < i) {
          for (; d.has(A); ) A = Math.floor(Math.random() * h);
          return l(d, A);
        }
        if (d.size > o) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
        for (; d.has(A); ) A = Math.floor(Math.random() * o);
        return l(d, A);
      };
    }, u = /* @__PURE__ */ new WeakMap(), f = s(u), p = c(f, u), g = n(p);
    t.addUniqueNumber = g, t.generateUniqueNumber = p;
  });
});
Jn(Zn());
var ue = (typeof window > "u" ? "undefined" : typeof window) == "object", ee = { setTimeout: ue ? setTimeout.bind(window) : setTimeout, clearTimeout: ue ? clearTimeout.bind(window) : clearTimeout, setInterval: ue ? setInterval.bind(window) : setInterval, clearInterval: ue ? clearInterval.bind(window) : clearInterval };
function $n(e) {
  ee.setTimeout = e.setTimeout, ee.clearTimeout = e.clearTimeout, ee.setInterval = e.setInterval, ee.clearInterval = e.clearInterval;
}
var Ie = {}, eo = class {
  constructor(e) {
    P(this, "name");
    P(this, "closed", !1);
    P(this, "mc", new MessageChannel());
    this.name = e, Ie[e] = Ie[e] || [], Ie[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
  }
  onStorage(e) {
    if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
    let r = JSON.parse(e.newValue);
    this.mc.port2.postMessage(r);
  }
  postMessage(e) {
    if (this.closed) throw new Error("InvalidStateError");
    let r = JSON.stringify(e), t = `${this.name}:${String(Date.now())}${String(Math.random())}`;
    window.localStorage.setItem(t, r), ee.setTimeout(() => {
      window.localStorage.removeItem(t);
    }, 500), Ie[this.name].forEach((n) => {
      n !== this && n.mc.port2.postMessage(JSON.parse(r));
    });
  }
  close() {
    if (this.closed) return;
    this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
    let e = Ie[this.name].indexOf(this);
    Ie[this.name].splice(e, 1);
  }
  get onmessage() {
    return this.mc.port1.onmessage;
  }
  set onmessage(e) {
    this.mc.port1.onmessage = e;
  }
  get onmessageerror() {
    return this.mc.port1.onmessageerror;
  }
  set onmessageerror(e) {
    this.mc.port1.onmessageerror = e;
  }
  addEventListener(e, r) {
    return this.mc.port1.addEventListener(e, r);
  }
  removeEventListener(e, r) {
    return this.mc.port1.removeEventListener(e, r);
  }
  dispatchEvent(e) {
    return this.mc.port1.dispatchEvent(e);
  }
}, to = typeof window > "u" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : eo;
function ro(e = 0) {
  return new Promise((r) => ee.setTimeout(r, e));
}
function Jt() {
  return Math.random().toString(36).substring(2);
}
var no = class {
  constructor(e, r) {
    P(this, "options");
    P(this, "channel");
    P(this, "token", Jt());
    P(this, "isLeader", !1);
    P(this, "isDead", !1);
    P(this, "isApplying", !1);
    P(this, "reApply", !1);
    P(this, "intervals", []);
    P(this, "listeners", []);
    P(this, "deferred");
    this.channel = e, this.options = r, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }
  async apply() {
    if (this.isLeader || this.isDead) return !1;
    if (this.isApplying) return this.reApply = !0, !1;
    this.isApplying = !0;
    let e = !1, r = (t) => {
      let { token: n, action: s } = t.data;
      n !== this.token && (s === 0 && n > this.token && (e = !0), s === 1 && (e = !0));
    };
    this.channel.addEventListener("message", r);
    try {
      return this.sendAction(0), await ro(this.options.responseTime), this.channel.removeEventListener("message", r), this.isApplying = !1, e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0);
    } catch {
      return !1;
    }
  }
  awaitLeadership() {
    if (this.isLeader) return Promise.resolve();
    let e = !1, r = null;
    return new Promise((t) => {
      let n = () => {
        if (e) return;
        e = !0;
        try {
          ee.clearInterval(r);
        } catch {
        }
        let o = this.intervals.indexOf(r);
        o >= 0 && this.intervals.splice(o, 1), this.channel.removeEventListener("message", s), t();
      };
      r = ee.setInterval(() => {
        this.apply().then(() => {
          this.isLeader && n();
        });
      }, this.options.fallbackInterval), this.intervals.push(r);
      let s = (o) => {
        let { action: i } = o.data;
        i === 2 && this.apply().then(() => {
          this.isLeader && n();
        });
      };
      this.channel.addEventListener("message", s);
    });
  }
  sendAction(e) {
    this.channel.postMessage({ action: e, token: this.token });
  }
  assumeLead() {
    this.isLeader = !0;
    let e = (r) => {
      let { action: t } = r.data;
      t === 0 && this.sendAction(1);
    };
    return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(1);
  }
  waitForLeadership() {
    return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
  }
  close() {
    if (!this.isDead) {
      this.isDead = !0, this.isLeader = !1, this.sendAction(2);
      try {
        this.listeners.forEach((e) => this.channel.removeEventListener("message", e)), this.intervals.forEach((e) => ee.clearInterval(e));
      } catch {
      }
    }
  }
}, oo = class {
  constructor(e) {
    P(this, "channel");
    P(this, "options");
    P(this, "elector");
    P(this, "token", Jt());
    P(this, "registry", /* @__PURE__ */ new Map());
    P(this, "allIdle", !1);
    P(this, "isLastActive", !1);
    let { channelName: r } = e;
    if (this.options = e, this.channel = new to(r), this.registry.set(this.token, 1), e.leaderElection) {
      let t = { fallbackInterval: 2e3, responseTime: 100 };
      this.elector = new no(this.channel, t), this.elector.waitForLeadership();
    }
    this.channel.addEventListener("message", (t) => {
      let { action: n, token: s, data: o } = t.data;
      switch (n) {
        case 3:
          this.registry.set(s, 2);
          break;
        case 4:
          this.registry.delete(s);
          break;
        case 5:
          this.idle(s);
          break;
        case 6:
          this.active(s);
          break;
        case 7:
          this.prompt(s);
          break;
        case 8:
          this.start(s);
          break;
        case 9:
          this.reset(s);
          break;
        case 10:
          this.activate(s);
          break;
        case 11:
          this.pause(s);
          break;
        case 12:
          this.resume(s);
          break;
        case 13:
          this.options.onMessage(o);
          break;
      }
    }), this.send(3);
  }
  get isLeader() {
    if (!this.elector) throw new Error('❌ Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
    return this.elector.isLeader;
  }
  prompt(e = this.token) {
    this.registry.set(e, 0);
    let r = [...this.registry.values()].every((t) => t === 0);
    e === this.token && this.send(7), r && this.options.onPrompt();
  }
  idle(e = this.token) {
    this.registry.set(e, 2);
    let r = [...this.registry.values()].every((t) => t === 2);
    e === this.token && this.send(5), !this.allIdle && r && (this.allIdle = !0, this.options.onIdle());
  }
  active(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1);
    let r = [...this.registry.values()].some((t) => t === 1);
    e === this.token && this.send(6), r && this.options.onActive(), this.isLastActive = e === this.token;
  }
  start(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(8) : this.options.start(!0), this.isLastActive = e === this.token;
  }
  reset(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(9) : this.options.reset(!0), this.isLastActive = e === this.token;
  }
  activate(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(10) : this.options.activate(!0), this.isLastActive = e === this.token;
  }
  pause(e = this.token) {
    e === this.token ? this.send(11) : this.options.pause(!0);
  }
  resume(e = this.token) {
    e === this.token ? this.send(12) : this.options.resume(!0);
  }
  message(e) {
    try {
      this.channel.postMessage({ action: 13, token: this.token, data: e });
    } catch {
    }
  }
  send(e) {
    try {
      this.channel.postMessage({ action: e, token: this.token });
    } catch {
    }
  }
  close() {
    this.options.leaderElection && this.elector.close(), this.send(4), this.channel.close();
  }
}, so = ue ? document : null, ao = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange", "focus"];
function io(e, r) {
  let t;
  function n(...s) {
    t && clearTimeout(t), t = setTimeout(() => {
      e(...s), t = null;
    }, r);
  }
  return n.cancel = function() {
    clearTimeout(t);
  }, n;
}
function rt(e, r) {
  let t = 0;
  return function(...n) {
    let s = (/* @__PURE__ */ new Date()).getTime();
    if (!(s - t < r)) return t = s, e(...n);
  };
}
var M = () => Date.now(), Te = 2147483647;
function co({ timeout: e = 1e3 * 60 * 20, promptTimeout: r = 0, promptBeforeIdle: t = 0, element: n = so, events: s = ao, timers: o = void 0, immediateEvents: i = [], onPresenceChange: h = () => {
}, onPrompt: c = () => {
}, onIdle: u = () => {
}, onActive: f = () => {
}, onAction: p = () => {
}, onMessage: g = () => {
}, debounce: l = 0, throttle: E = 0, eventsThrottle: d = 200, startOnMount: y = !0, startManually: A = !1, stopOnIdle: U = !1, crossTab: I = !1, name: O = "idle-timer", syncTimers: re = 0, leaderElection: H = !1, disabled: N = !1 } = {}) {
  let ne = w(M()), W = w(M()), B = w(null), q = w(null), oe = w(0), me = w(0), G = w(0), j = w(0), T = w(!1), C = w(!1), D = w(!1), x = w(!0), ce = w(!1), le = w(null), b = w(null), J = w(e), pe = w(0);
  S(() => {
    if (r && console.warn("⚠️ IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), t && r) throw new Error("❌ Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
    if (e >= Te) throw new Error(`❌ The value for the timeout property must fit in a 32 bit signed integer, ${Te}.`);
    if (r >= Te) throw new Error(`❌ The value for the promptTimeout property must fit in a 32 bit signed integer, ${Te}.`);
    if (t >= Te) throw new Error(`❌ The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${Te}.`);
    if (t >= e) throw new Error(`❌ The value for the promptBeforeIdle property must be less than the timeout property, ${e}.`);
    if (t ? (J.current = e - t, pe.current = t) : (J.current = e, pe.current = r), !x.current) {
      if (A || N) return;
      T.current && (Ae.current(null, Y), b.current && b.current.active()), ve();
    }
  }, [e, r, t, A, N]);
  let pt = w(U);
  S(() => {
    pt.current = U;
  }, [U]);
  let ft = w(i), ke = w(n), Xe = w([...(/* @__PURE__ */ new Set([...s, ...i])).values()]), Z = w(N);
  S(() => {
    Z.current = N, !x.current && (N ? je() : A || ve());
  }, [N]);
  let xe = w(h);
  S(() => {
    xe.current = h;
  }, [h]);
  let Be = w(c);
  S(() => {
    Be.current = c;
  }, [c]);
  let _e = w(u);
  S(() => {
    _e.current = u;
  }, [u]);
  let Ae = w(f);
  S(() => {
    Ae.current = f;
  }, [f]);
  let Ve = w(p);
  S(() => {
    Ve.current = p;
  }, [p]);
  let ye = w(g);
  S(() => {
    ye.current = g;
  }, [g]);
  let fe = De(() => {
    let m = (z, ze) => Ve.current(z, ze);
    return l > 0 ? io(m, l) : E > 0 ? rt(m, E) : m;
  }, [E, l]), gt = w();
  S(() => {
    I && re && (gt.current = rt(() => {
      b.current.active();
    }, re));
  }, [I, re]);
  let $ = () => {
    le.current !== null && (ee.clearTimeout(le.current), le.current = null);
  }, ge = (m, z = !0) => {
    $(), le.current = ee.setTimeout(Ze, m || J.current), z && (q.current = M());
  }, Et = (m) => {
    !C.current && !T.current && (Be.current(m, Y), xe.current({ type: "active", prompted: !0 }, Y)), j.current = 0, G.current = M(), C.current = !0, ge(pe.current, !1);
  }, vt = () => {
    $(), T.current || (_e.current(null, Y), xe.current({ type: "idle" }, Y)), T.current = !0, B.current = M(), pt.current ? Ee() : C.current && (G.current = 0, C.current = !1);
  }, Je = (m) => {
    $(), (T.current || C.current) && (Ae.current(m, Y), xe.current({ type: "active", prompted: !1 }, Y)), C.current = !1, G.current = 0, T.current = !1, oe.current += M() - B.current, me.current += M() - B.current, de(), ge();
  }, Ze = (m) => {
    if (!T.current) {
      fe.cancel && fe.cancel();
      let z = M() - q.current;
      if (!(J.current + pe.current < z) && pe.current > 0 && !C.current) {
        b.current ? b.current.prompt() : Et(m);
        return;
      }
      b.current ? b.current.idle() : vt();
      return;
    }
    b.current ? b.current.active() : Je(m);
  }, $e = (m) => {
    if (!y && !q.current && (q.current = M(), Ae.current(null, Y)), fe(m, Y), C.current) return;
    if ($(), !T.current && ft.current.includes(m.type)) {
      Ze(m);
      return;
    }
    let z = M() - q.current;
    if (T.current && !U || !T.current && z >= J.current) {
      Ze(m);
      return;
    }
    D.current = !1, j.current = 0, G.current = 0, ge(), I && re && gt.current();
  }, We = w($e);
  S(() => {
    let m = ce.current;
    m && Ee(), d > 0 ? We.current = rt($e, d) : We.current = $e, m && de();
  }, [d, E, l, Ve, I, re]);
  let de = () => {
    ue && ke.current && (ce.current || (Xe.current.forEach((m) => {
      ke.current.addEventListener(m, We.current, { capture: !0, passive: !0 });
    }), ce.current = !0));
  }, Ee = (m = !1) => {
    ue && ke.current && (ce.current || m) && (Xe.current.forEach((z) => {
      ke.current.removeEventListener(z, We.current, { capture: !0 });
    }), ce.current = !1);
  }, ve = v((m) => Z.current ? !1 : ($(), de(), T.current = !1, C.current = !1, D.current = !1, j.current = 0, G.current = 0, b.current && !m && b.current.start(), ge(), !0), [le, T, Z, J, b]), et = v((m) => Z.current ? !1 : ($(), de(), W.current = M(), oe.current += M() - B.current, me.current += M() - B.current, oe.current = 0, T.current = !1, C.current = !1, D.current = !1, j.current = 0, G.current = 0, b.current && !m && b.current.reset(), A || ge(), !0), [le, T, J, A, Z, b]), bt = v((m) => Z.current ? !1 : ($(), de(), (T.current || C.current) && Je(), T.current = !1, C.current = !1, D.current = !1, j.current = 0, G.current = 0, W.current = M(), b.current && !m && b.current.activate(), ge(), !0), [le, T, C, Z, J, b]), je = v((m = !1) => Z.current || D.current ? !1 : (j.current = wt(), D.current = !0, Ee(), $(), b.current && !m && b.current.pause(), !0), [le, Z, b]), tt = v((m = !1) => Z.current || !D.current ? !1 : (D.current = !1, C.current || de(), T.current || ge(j.current), G.current && (G.current = M()), b.current && !m && b.current.resume(), !0), [le, J, Z, j, b]), nr = v((m, z) => (b.current ? (z && ye.current(m, Y), b.current.message(m)) : z && ye.current(m, Y), !0), [g]), or = v(() => T.current, [T]), sr = v(() => C.current, [C]), ar = v(() => b.current ? b.current.isLeader : null, [b]), ir = v(() => b.current ? b.current.isLastActive : null, [b]), cr = v(() => b.current ? b.current.token : null, [b]), wt = v(() => {
    if (D.current) return j.current;
    let m = j.current ? j.current : pe.current + J.current, z = q.current ? M() - q.current : 0, ze = Math.floor(m - z);
    return ze < 0 ? 0 : Math.abs(ze);
  }, [J, pe, C, j, q]), At = v(() => Math.round(M() - W.current), [W]), yt = v(() => Math.round(M() - ne.current), [ne]), lr = v(() => B.current ? new Date(B.current) : null, [B]), ur = v(() => q.current ? new Date(q.current) : null, [q]), It = v(() => T.current ? Math.round(M() - B.current + oe.current) : Math.round(oe.current), [B, oe]), Tt = v(() => T.current ? Math.round(M() - B.current + me.current) : Math.round(me.current), [B, me]), dr = v(() => {
    let m = Math.round(At() - It());
    return m >= 0 ? m : 0;
  }, [B, oe]), hr = v(() => {
    let m = Math.round(yt() - Tt());
    return m >= 0 ? m : 0;
  }, [B, oe]);
  S(() => {
    if (l > 0 && E > 0) throw new Error("❌ onAction can either be throttled or debounced, not both.");
    o && $n(o);
    let m = () => {
      b.current && b.current.close(), fe.cancel && fe.cancel(), $(), Ee(!0);
    };
    return ue && window.addEventListener("beforeunload", m), () => {
      ue && window.removeEventListener("beforeunload", m), b.current && b.current.close(), fe.cancel && fe.cancel(), $(), Ee(!0);
    };
  }, []), S(() => {
    b.current && b.current.close(), I ? b.current = new oo({ channelName: O, leaderElection: H, onPrompt: () => {
      Et();
    }, onIdle: () => {
      vt();
    }, onActive: () => {
      Je();
    }, onMessage: (m) => {
      ye.current(m, Y);
    }, start: ve, reset: et, activate: bt, pause: je, resume: tt }) : b.current = null;
  }, [I, O, H, Be, _e, Ae, ye, ve, et, je, tt]), S(() => {
    x.current || ($(), Ee(!0)), !(A || N) && (y ? ve() : de());
  }, [A, y, N, x]), S(() => {
    if (!x.current) {
      let m = [...(/* @__PURE__ */ new Set([...s, ...i])).values()];
      if (Ee(), Xe.current = m, ke.current = n, ft.current = i, A || N) return;
      y ? ve() : de();
    }
  }, [n, JSON.stringify(s), JSON.stringify(i), x, N, A, y]), S(() => {
    x.current && (x.current = !1);
  }, [x]);
  let Y = { message: nr, start: ve, reset: et, activate: bt, pause: je, resume: tt, isIdle: or, isPrompted: sr, isLeader: ar, isLastActiveTab: ir, getTabId: cr, getRemainingTime: wt, getElapsedTime: At, getTotalElapsedTime: yt, getLastIdleTime: lr, getLastActiveTime: ur, getIdleTime: It, getTotalIdleTime: Tt, getActiveTime: dr, getTotalActiveTime: hr, setOnPresenceChange: (m) => {
    h = m, xe.current = m;
  }, setOnPrompt: (m) => {
    c = m, Be.current = m;
  }, setOnIdle: (m) => {
    u = m, _e.current = m;
  }, setOnActive: (m) => {
    f = m, Ae.current = m;
  }, setOnAction: (m) => {
    p = m, Ve.current = m;
  }, setOnMessage: (m) => {
    g = m, ye.current = m;
  } };
  return Y;
}
var lo = Mt(null);
lo.Consumer;
function uo(e) {
  return (r) => {
    const t = w(null), n = r.onCancel;
    return S(() => {
      const s = (i) => {
        i.key === "Escape" && n();
      }, o = t.current;
      return o == null || o.addEventListener("keydown", s), () => {
        o == null || o.removeEventListener("keydown", s);
      };
    }, [n]), /* @__PURE__ */ a("div", { ref: t, children: /* @__PURE__ */ a(e, { ...r }) });
  };
}
const ho = (e) => /* @__PURE__ */ K.createElement("svg", { width: 140, height: 88, viewBox: "0 0 140 88", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ K.createElement("rect", { y: 16, width: 140, height: 72, rx: 10, fill: "#DDDEEA" }), /* @__PURE__ */ K.createElement("rect", { x: 2.5, y: 18.5, width: 135, height: 67, rx: 7.5, stroke: "#BBBDD6", strokeWidth: 5 }), /* @__PURE__ */ K.createElement("path", { d: "M0 26C0 20.4772 4.47715 16 10 16H61V88H10C4.47715 88 0 83.5229 0 78V26Z", fill: "#999DC1" }), /* @__PURE__ */ K.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.9994 43.9998C38.9994 48.418 35.4177 51.9996 30.9996 51.9996C26.5814 51.9996 22.9998 48.418 22.9998 43.9998C22.9998 39.5816 26.5814 36 30.9996 36C35.4177 36 38.9994 39.5816 38.9994 43.9998ZM36.3328 43.9998C36.3328 46.9452 33.945 49.333 30.9996 49.333C28.0541 49.333 25.6664 46.9452 25.6664 43.9998C25.6664 41.0543 28.0541 38.6666 30.9996 38.6666C33.945 38.6666 36.3328 41.0543 36.3328 43.9998Z", fill: "white" }), /* @__PURE__ */ K.createElement("path", { d: "M31 54.6662C38.8273 54.6662 45.2929 60.3968 47 67.9992H44.2579C42.6157 61.8056 37.255 57.3328 31 57.3328C24.7449 57.3328 19.3843 61.8056 17.7421 67.9992H15C16.7071 60.3968 23.1727 54.6662 31 54.6662Z", fill: "white" }), /* @__PURE__ */ K.createElement("rect", { x: 0.5, y: 16.5, width: 139, height: 71, rx: 9.5, stroke: "#33375B" }), /* @__PURE__ */ K.createElement("path", { d: "M62 8C62 3.58172 65.5817 0 70 0C74.4183 0 78 3.58172 78 8V16H62V8Z", fill: "#33375B" }), /* @__PURE__ */ K.createElement("rect", { x: 73, y: 59, width: 24, height: 2, rx: 1, fill: "#999DC1" }), /* @__PURE__ */ K.createElement("rect", { x: 73, y: 53, width: 32, height: 2, rx: 1, fill: "#999DC1" }), /* @__PURE__ */ K.createElement("rect", { x: 73, y: 47, width: 42, height: 2, rx: 1, fill: "#999DC1" }), /* @__PURE__ */ K.createElement("rect", { x: 73, y: 41, width: 52, height: 2, rx: 1, fill: "#999DC1" }), /* @__PURE__ */ K.createElement("circle", { cx: 70, cy: 7, r: 4, fill: "white" })), mo = Cr(({ label: e }, r) => /* @__PURE__ */ k("div", { "data-testid": "prox-card", ref: r, children: [
  /* @__PURE__ */ a("div", { className: "formLabel subtitle", "data-testid": "prox-text-label", children: /* @__PURE__ */ a("div", { dangerouslySetInnerHTML: { __html: e } }) }),
  /* @__PURE__ */ a(ho, { "data-testid": "prox-card-icon" })
] })), po = ({
  initUsernameValue: e = "",
  initPasswordValue: r = "",
  disabled: t = !1,
  onSubmit: n,
  onCancel: s,
  usernameLabel: o = "",
  passwordLabel: i = "",
  ...h
}) => {
  const c = w(null), u = lt(), { t: f } = V(), [p, g] = F(e), [l, E] = F(r), d = Ue(), y = !(p != null && p.length) || !(l != null && l.length) || t, A = (N) => {
    N.nativeEvent.globalTimerIgnore = !0, g(N.target.value.trim());
  }, U = (N) => {
    N.nativeEvent.globalTimerIgnore = !0, E(N.target.value.trim());
  }, I = (N) => {
    N == null || N.preventDefault(), !y && n(p, l);
  }, O = (N) => {
    N.nativeEvent.disableGlobal = !0, console.log("ENROLLPROX: ", N);
  }, re = o ? f("login.username.custom-label", {
    username: o,
    // Prevent HTML Entities from being screened twice - by i18n function and then by react
    interpolation: { escapeValue: !1 }
  }) : f("login.username.label"), H = i ? f("login.password.custom-label", {
    password: i,
    // Prevent HTML Entities from being screened twice - by i18n function and then by react
    interpolation: { escapeValue: !1 }
  }) : f("login.password.label");
  return S(() => {
    var N;
    t || (N = u.current) == null || N.focus();
  }, [t, u]), /* @__PURE__ */ a("div", { ...h, className: `enrollCardWrapper ${h.className || ""}`, children: /* @__PURE__ */ k("form", { onSubmit: I, autoComplete: "off", children: [
    /* @__PURE__ */ k("div", { className: "enrollCardHeader", children: [
      /* @__PURE__ */ a("div", { "data-testid": "general-message", className: "h3-header", children: f("enroll.header-line-1") }),
      /* @__PURE__ */ a("div", { "data-testid": "general-message-2", className: "enrollSubtitle primary-body", children: f("enroll.header-line-2") })
    ] }),
    /* @__PURE__ */ a(
      "label",
      {
        htmlFor: `enroll-prox-username-${d}`,
        "data-testid": "username-input-label",
        className: "enrollFormLabel secondary-body",
        children: re
      }
    ),
    /* @__PURE__ */ a(
      Le,
      {
        ref: u,
        type: "text",
        autoComplete: "off",
        placeholder: "",
        value: p,
        "data-testid": "username-input",
        onChange: A,
        autoFocus: !t,
        disabled: t,
        width: "100%",
        size: "large",
        id: `enroll-prox-username-${d}`,
        onInput: O,
        onPressEnter: (N) => {
          var ne;
          N.preventDefault(), (ne = c.current) == null || ne.focus();
        }
      }
    ),
    /* @__PURE__ */ a(
      "label",
      {
        htmlFor: `enroll-prox-password-${d}`,
        "data-testid": "password-input-label",
        className: "enrollFormLabel secondary-body",
        style: { marginTop: "21px" },
        children: H
      }
    ),
    /* @__PURE__ */ a(
      Le,
      {
        ref: c,
        type: "password",
        placeholder: "",
        value: l,
        "data-testid": "password-input",
        onChange: U,
        disabled: t,
        onPressEnter: I,
        width: "100%",
        size: "large",
        id: `enroll-prox-password-${d}`,
        capsLockTooltip: { label: f("password.caps-lock-tooltip") }
      }
    ),
    /* @__PURE__ */ k("div", { className: "enrollCardButtons", children: [
      /* @__PURE__ */ a(
        Q,
        {
          type: "primary",
          size: "large",
          className: "action-button",
          label: f("actions.assign") || void 0,
          disabled: y,
          "data-testid": "submit-button",
          block: !0,
          htmlType: "submit"
        }
      ),
      /* @__PURE__ */ a(
        Q,
        {
          type: "text",
          size: "large",
          className: "action-button",
          label: f("actions.cancel") || void 0,
          disabled: t,
          "data-testid": "cancel-button",
          block: !0,
          onClick: s
        }
      )
    ] })
  ] }) });
}, Zt = (e) => {
  var l;
  const { t: r } = V(), { toggleFactorSwitch: t } = ae(), { loading: n, error: s, emitEvent: o } = ie(), [i, h] = F(), c = (l = e.orgPreferences) != null && l.proxCardLabel ? r("login.proxcard.custom-label", { card: e.orgPreferences.proxCardLabel }) : r("login.proxcard.label"), u = v((E) => {
    h(E);
  }, []), f = v(() => {
    h(void 0), o({ event: L.INTERNAL_RESTART });
  }, [o]), p = v(() => {
    h(void 0), o({ event: L.TERMINATE_SESSION, data: Re.CANCEL });
  }, [o]);
  S(() => {
    t(!!i);
  }, [i, t]);
  const g = De(() => s ? Date.now().toString() : "prox-card-enroll", [s]);
  return /* @__PURE__ */ a("div", { children: i ? /* @__PURE__ */ Lt(
    go,
    {
      ...e,
      authnData: i,
      loading: n,
      onSuccess: f,
      onCancel: p,
      key: g
    }
  ) : /* @__PURE__ */ Lt(fo, { ...e, label: c, onEnroll: u, key: g }) });
}, fo = (e) => {
  const { callbacks: r, onEnroll: t } = e, { subscribeToAuthnDataReady: n } = r || {}, s = w(null), { authenticate: o } = ae(), [i, h] = F(!1);
  return S(() => {
    !i && n && (n((c, { traceContext: u, authnData: f }) => {
      var g;
      const p = new MouseEvent("click", { bubbles: !0 });
      (g = s.current) == null || g.dispatchEvent(p), document.dispatchEvent(p), o(f, !1, !1, u).then((l) => {
        l instanceof Ur && t(f);
      });
    }), h(!0));
  }, [i, o, n, t]), /* @__PURE__ */ a(mo, { ref: s, label: e == null ? void 0 : e.label });
};
function $t(e) {
  var p, g;
  const { authnData: r, loading: t, onSuccess: n, onCancel: s } = e, { emitEvent: o } = ie(), { authenticate: i, enroll: h, updateAuthState: c, terminateSession: u } = ae();
  co({
    name: "enroll-form-timeout",
    timeout: _r * 1e3,
    events: at,
    onIdle: () => {
      console.log("[Authn::TIMER] (enroll) idle event"), u(Re.TIMEOUT);
    }
  });
  const f = v(
    (l, E) => {
      c({ username: l, userKnown: !0 }), i(
        we(R.PASSWORD, { version: "1.0", username: l, password: E }),
        !0
      ).then(async (d) => {
        if (d instanceof Ne)
          throw d;
        d != null && d.session ? await h(r, d.session) : o({
          event: L.INTERNAL_RESTART,
          data: new Br({ code: Ge.INTERNAL })
        });
      }).then(() => {
        n();
      }).catch((d) => {
        console.error("ProxCardEnroll: error", d);
      });
    },
    [r, h, i, c, n, o]
  );
  return /* @__PURE__ */ a("div", { className: ["flex", "flex-justify-center", "prox-enrollment"].join(" "), children: /* @__PURE__ */ a(
    po,
    {
      "data-testid": "enroll-prox-form",
      disabled: t,
      onSubmit: f,
      onCancel: s,
      usernameLabel: (p = e.orgPreferences) == null ? void 0 : p.usernameLabel,
      passwordLabel: (g = e.orgPreferences) == null ? void 0 : g.passwordLabel
    }
  ) });
}
const go = uo($t);
Zt.whyDidYouRender = !0;
$t.whyDidYouRender = !0;
const er = ({
  requestConfig: e,
  orgPreferences: r
}) => {
  const { username: t } = e || {}, { loading: n, error: s, emitEvent: o } = ie(), {
    state: { username: i, userKnown: h },
    authenticate: c,
    terminateSession: u,
    updateAuthState: f
  } = ae(), p = !t && !h, [g, l] = F(!1), E = De(() => s ? Date.now().toString() : "passwordForm", [s]), d = () => {
    u(Re.CANCEL), f({ username: void 0 });
  }, y = (I) => {
    f({ username: I }), o({ event: L.RESTART_STATE });
  }, A = v(
    (I) => {
      c(
        we(R.PASSWORD, {
          version: "1.0",
          // in some cases username is empty. If so, it should not be sent.
          ...i ? { username: i } : {},
          password: I
        })
      ).then((O) => {
        se(O) || l(!0);
      });
    },
    [i, c]
  );
  return /* @__PURE__ */ a("div", { className: "w-100", children: i || t || h ? /* @__PURE__ */ a(
    Ht,
    {
      disabled: n || g,
      onSubmit: A,
      allowChangeUsername: p,
      onChangeUsername: d,
      username: i,
      error: s == null ? void 0 : s.message
    },
    E
  ) : /* @__PURE__ */ a(_, { children: /* @__PURE__ */ a(
    zt,
    {
      initValue: i,
      disabled: !1,
      onSubmit: y,
      usernameLabel: r == null ? void 0 : r.usernameLabel
    }
  ) }) });
};
er.whyDidYouRender = !0;
const Se = ht, tr = (e) => {
  const { t: r } = V(), t = w(null), { loading: n, error: s } = ie(), {
    state: { username: o, nextFactors: i },
    terminateSession: h
  } = ae(), c = (i == null ? void 0 : i.length) && i[0] || void 0;
  te("[Authn::Controller]", { nextFactors: i, current: c, error: s });
  const u = /* @__PURE__ */ a(_, { children: n ? /* @__PURE__ */ a("div", { children: r("login.loading") }) : /* @__PURE__ */ a("h4", { children: r("errors.unknown-auth-method", { method: (c == null ? void 0 : c.factorType) || "unknown" }) }) }), f = v(() => {
    e.isTimerDisabled || h(Re.TIMEOUT);
  }, [h, e.isTimerDisabled]);
  return s && s instanceof Ut ? /* @__PURE__ */ a(ut, { error: s }) : /* @__PURE__ */ a(
    "div",
    {
      ref: t,
      className: [
        "flex",
        "flex-column",
        "flex-grow-1",
        "flex-align-center",
        "flex-justify-space-between",
        "h-100",
        "w-100"
      ].join(" "),
      children: /* @__PURE__ */ k(mt, { current: c == null ? void 0 : c.factorType, fallback: u, children: [
        /* @__PURE__ */ a(Se, { factor: R.FACE_ID, Component: Kt, ...e }),
        /* @__PURE__ */ a(Se, { factor: R.PASSWORD, Component: er, ...e }),
        /* @__PURE__ */ a(Se, { factor: R.PROX, Component: Zt, ...e }),
        /* @__PURE__ */ a(Se, { factor: R.IMPR_ID, Component: it, ...e }),
        /* @__PURE__ */ a(Se, { factor: R.IMPR_PIN, Component: Gt, ...e }),
        /* @__PURE__ */ a(Se, { factor: R.IID_DISABLED, Component: it, ...e }),
        /* @__PURE__ */ a(
          qt,
          {
            container: t,
            onIdle: f,
            username: o,
            current: c == null ? void 0 : c.factorType
          }
        )
      ] })
    }
  );
};
tr.whyDidYouRender = !0;
const Eo = (e) => {
  const {
    tenantId: r,
    requestConfig: t,
    tracing: { workflowId: n }
  } = e, s = De(() => pn(e), [e]);
  S(() => {
    const i = async () => {
      await s.terminateSession(Re.CANCEL);
    };
    return ["popstate", "beforeunload"].map((h) => {
      window.addEventListener(h, i, { once: !0 });
    }), () => {
      setTimeout(() => {
        ["popstate", "beforeunload"].map((h) => {
          window.removeEventListener(h, i);
        });
      }, 0);
    };
  }, [s]), S(() => {
    t != null && t.clientName && Ce(
      he.ImprClientName,
      Wt({ name: t.clientName })
    ), Ce(he.ImprTenantId, r), n && Ce(he.ImprWorkflowId, n), console.debug("[App] default headers set");
  }, [r, t, n]), S(() => (wn(), () => {
    jt();
  }), []);
  const o = !0;
  return S(() => {
    console.debug("[useBootstrap] ready");
  }, []), { ready: o, apiService: s };
}, vo = `0.6.11 (common=${Ar})`, bo = `1751919324063 (common=${wr})`;
let Ot = !1;
const rr = ({
  tracing: e,
  deviceFactors: r,
  factors: t,
  requestConfig: n,
  hideFactorSwitch: s,
  isTimerDisabled: o,
  callbacks: i,
  onEvent: h,
  tenantId: c,
  orgPreferences: u,
  applicationId: f
}) => {
  const p = De(
    () => ({
      tracing: e,
      deviceFactors: r,
      factors: t,
      requestConfig: n,
      hideFactorSwitch: s,
      isTimerDisabled: o,
      callbacks: i,
      onEvent: h,
      tenantId: c,
      orgPreferences: u
    }),
    [
      e,
      r,
      t,
      n,
      s,
      o,
      i,
      h,
      c,
      u
    ]
  ), g = w(!1), l = Lr(), { apiService: E, ready: d } = Eo(p);
  return Ot || (console.debug("BUILD VERSION [authn]: ", bo), console.debug("APP VERSION [authn]: ", vo), Ot = !0), S(
    yr(nt(ot.UI, "load", "authn"), () => () => {
    }),
    []
  ), d && te("[Auth] initialized: ", p), S(() => {
    d && !g.current && (g.current = !0, X(nt(ot.UI, "ready", "authn")));
  }, [d]), /* @__PURE__ */ a(Vr, { fallback: /* @__PURE__ */ a(Wr, {}), children: /* @__PURE__ */ a(In, { fallback: /* @__PURE__ */ a(ut, {}), children: /* @__PURE__ */ a(nn, { onEvent: h, apiService: E, children: /* @__PURE__ */ a(on, { ...p, apiService: E, children: /* @__PURE__ */ a(
    Fn,
    {
      apiService: E,
      modalRoot: (l == null ? void 0 : l.current) ?? void 0,
      applicationId: f,
      children: /* @__PURE__ */ a(tr, { ...p })
    }
  ) }) }) }) });
};
rr.whyDidYouRender = !0;
const Fo = Nr(rr, br);
export {
  Fo as A
};
//# sourceMappingURL=Authn-R7ooN8bt.js.map
